import React from 'react';
import {
  Box,
  Container,
  SimpleGrid,
  Text,
  List,
  ListItem,
  Link as ExternalLink,
  Flex,
} from '@chakra-ui/react';
import { Link as InternalLink } from '@reach/router';
import TheLogo from '#coreComponents/logos/TheLogo';

export const footerPages: {
  title: string;
  links: { text: string; href: string }[];
}[] = [
  {
    title: 'About Us',
    links: [
      {
        text: 'About Times Higher Education',
        href: 'https://www.timeshighereducation.com/about-us',
      },
    ],
  },
  {
    title: 'Contact',
    links: [
      {
        text: 'General Enquiry',
        href: 'mailto:data@timeshighereducation.com',
      },
      {
        text: 'Customer Services',
        href: 'mailto:datapoints.support@timeshighereducation.com',
      },
    ],
  },
  {
    title: 'Other Services',
    links: [
      {
        text: 'Rankings',
        href: 'https://www.timeshighereducation.com/world-university-rankings',
      },
      {
        text: 'THE Summits',
        href: 'https://www.timeshighereducation.com/summits',
      },
    ],
  },
  {
    title: 'Legal',
    links: [
      {
        text: 'Cookie Policy',
        href: 'https://www.timeshighereducation.com/cookie-policy',
      },
      {
        text: 'Privacy Policy',
        href: 'https://www.timeshighereducation.com/privacy-policy',
      },
      {
        text: 'Accessibility Statement',
        href:
          'https://www.timeshighereducation.com/content/online-accessibility-statement',
      },
      {
        text: 'Terms and Conditions',
        href:
          'https://www.timeshighereducation.com/terms-and-conditions/datapoints',
      },
      {
        text: 'FAQs',
        href: '/datapoints/faqs',
      },
    ],
  },
];

export const HomeFooter = () => (
  <Box data-testid="footerContainer" bg="gray.700" pb={4}>
    <Container maxW="container.xl">
      <SimpleGrid
        flexGrow={1}
        alignItems="flex-start"
        pt={6}
        justifyContent="space-between"
        columns={[1, 2, 4]}
      >
        {footerPages.map(({ title, links }) => (
          <Box key={title}>
            <Text color="yellow.500" fontWeight="bold">
              {title}
            </Text>
            <List color="gray.100">
              {links.map(({ text, href }) => (
                <ListItem key={href} my={3} listStyleType="">
                  {href.startsWith('/') && !href.startsWith('//') ? (
                    <InternalLink to={href}>{text}</InternalLink>
                  ) : (
                    <ExternalLink href={href} isExternal cursor="pointer">
                      {text}
                    </ExternalLink>
                  )}
                </ListItem>
              ))}
            </List>
          </Box>
        ))}
      </SimpleGrid>
      <Flex color="gray.300" flexDirection="row" alignItems="flex-end">
        <TheLogo maxHeight={8} w={80} h={10} mr={2} />
        <Text>
          &copy; {new Date().getFullYear()} THE World Universities Insights
          Limited. All rights reserved.
        </Text>
      </Flex>
    </Container>
  </Box>
);

export default HomeFooter;
